"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatMaskedLengthString = exports.checkboxStatus = exports.verificationStatus = exports.formatCurrency = void 0;
/**
 * Format an amount as a currency value. This assumes that all locales, except for JPY,
 * will enter a value that is in cents. So 1000 cents becomes $10.00, but 2000 yen remains ￥2000<br>
 * [List of currency locales](https://help.sap.com/docs/SAP_BUSINESSOBJECTS_BUSINESS_INTELLIGENCE_PLATFORM/09382741061c40a989fae01e61d54202/46758c5e6e041014910aba7db0e91070.html?version=4.2.4)<br>
 * [List of currency codes](https://www.nationsonline.org/oneworld/currencies.htm)
 *
 * @param { number }amount Value to be converted into currency
 * @param { string } currencyLocale Optional. Defaults to "en-US"
 * @param { string } currency Optional. Defaults to "USD"
 * @returns { string } Formatted currency string
 * @example {{formatCurrency 250 "en-GB" "GBP"}} => £2.50
 * @example {{formatCurrency 2000 "ja-JP" "jpy"}} => ￥2000
 */
const formatCurrency = (amount, currencyLocale, currency) => {
    var _a;
    currency = (_a = currency === null || currency === void 0 ? void 0 : currency.toUpperCase()) !== null && _a !== void 0 ? _a : "USD";
    return isNaN(amount)
        ? "--"
        : new Intl.NumberFormat(currencyLocale || "en-US", {
            style: "currency",
            currency: currency,
        }).format(currency === "JPY" ? amount : amount / 100);
};
exports.formatCurrency = formatCurrency;
/**
 * Get a "Verified" or "Not Verified" string based on boolean
 * @param { boolean } checked Boolean value to check for corresponding string
 * @returns { string } If checked is True, returns "Verified", otherwise "Not Verified"
 * @example checkboxStatus(true) => "Verified"
 */
const verificationStatus = (checked) => {
    return checked ? "Verified" : "Not Verified";
};
exports.verificationStatus = verificationStatus;
/**
 * Get a "Yes" or "No" string based on boolean
 * @param { boolean } checked Boolean value to check for corresponding string
 * @returns { string } If checked is True, returns "Yes", otherwise "No"
 * @example checkboxStatus(false) => "No"
 */
const checkboxStatus = (checked) => {
    return checked ? "Yes" : "No";
};
exports.checkboxStatus = checkboxStatus;
/**
 * Converts numbers into a formatted string by adding a "+" before final 2 digits
 * @param { string } value String of numbers to be converted into a masked length string
 * @returns { string } Masked Length string
 * @example formatMaskedLengthString("2000") => "20+00"
 * @example formatMaskedLengthString("123") => "1+23"
 * @example formatMaskedLengthString("14") => "+14"
 * @example formatMaskedLengthString("3") => "+03"
 */
const formatMaskedLengthString = (value) => {
    if (!value) {
        return "";
    }
    value = parseInt(value).toString(); // removes any leading zeros and accounts for a number type
    const paddedValue = value.padStart(2, "0");
    const left = paddedValue.slice(0, -2);
    const right = paddedValue.slice(-2);
    return `${left}+${right}`;
};
exports.formatMaskedLengthString = formatMaskedLengthString;
